// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  height: 3.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
  padding: 0 24px;
  background: #ffffff;
}

.header-container .logo img {
  height: 40px;
}

.logo-dots {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3px;
  width: 32px;
  height: 32px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  justify-items: center;
}

.logo-dots > div {
  width: 8px !important;
  height: 8px !important;
}

.dot-animation {
  -webkit-animation: pulse 2s infinite;
          animation: pulse 2s infinite;
}

.dot-1 {
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
}

.dot-2 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s;
}

.dot-3 {
  -webkit-animation-delay: 0.4s;
          animation-delay: 0.4s;
}

.dot-4 {
  -webkit-animation-delay: 0.6s;
          animation-delay: 0.6s;
}

.dot-5 {
  -webkit-animation-delay: 0.8s;
          animation-delay: 0.8s;
}

.dot-6 {
  -webkit-animation-delay: 1.0s;
          animation-delay: 1.0s;
}

.dot-7 {
  -webkit-animation-delay: 1.2s;
          animation-delay: 1.2s;
}

.dot-8 {
  -webkit-animation-delay: 1.4s;
          animation-delay: 1.4s;
}

@-webkit-keyframes pulse {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }
}

/* Navigation tabs hosted inside the header, between the logo and the profile.
   Stretch to the full header height and bottom-align so the header's own
   border-bottom doubles as the tab baseline: inactive tabs rest on that line
   and the active tab's ink bar sits right on it. */

.header-tabs {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-width: 0;
  -ms-flex-item-align: stretch;
      align-self: stretch;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
  margin-left: 24px;
  overflow: hidden;
}

.header-tabs .ant-tabs {
  width: 100%;
  height: 100%;
}

/* Fill the header height so the ink bar lands on the header's bottom border */

.header-tabs .ant-tabs-nav {
  margin: 0;
  height: 100%;
}

/* Vertically center the labels; the ink bar stays pinned to the bottom = border */

.header-tabs .ant-tabs-nav-wrap {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

/* Compact tab items: smaller vertical padding + 13px label so they fit the bar */

.header-tabs .ant-tabs-tab {
  padding: 0.5rem 0 !important;
  font-size: 13px;
}

.header-tabs .ant-tabs-tab + .ant-tabs-tab {
  margin: 0 0 0 1.5rem;
}

.header-tabs .ant-tabs-tab .anticon {
  font-size: 14px;
  margin: 0;
}

.header-tabs .ant-tabs-nav::before {
  border-bottom: none;
}

.header-tabs .ant-tabs-top > .ant-tabs-nav {
  background: transparent !important;
}

/* No empty content panel needed — labels only */

.header-tabs .ant-tabs-content-holder {
  display: none;
}

.header-right-section {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-left: auto;
}

.profile-section {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
}

.profile-name-dropdown {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  color: #262626;
  text-decoration: none;
  cursor: pointer;
  padding: 8px 2px;
  border-radius: 6px;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.profile-name-dropdown:hover {
  background-color: #f5f5f5;
  color: #262626;
  text-decoration: none;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #262626;
}

.dropdown-arrow {
  font-size: 10px;
  color: #8c8c8c;
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
  transition: transform 0.2s, -webkit-transform 0.2s;
}

.profile-name-dropdown:hover .dropdown-arrow {
  -webkit-transform: translateY(1px);
          transform: translateY(1px);
}

.logo-text {
  font-family: Inter;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.04px;
  color: #1f2937;
}
`, "",{"version":3,"sources":["webpack://./pages/header/header.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,2BAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,2BAAmB;YAAnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAAqB;YAArB,qBAAqB;EACvB;AACF;;AATA;EACE;IACE,UAAU;IACV,2BAAmB;YAAnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,6BAAqB;YAArB,qBAAqB;EACvB;AACF;;AAEA;;;mDAGmD;;AACnD;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,4BAAmB;MAAnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8EAA8E;;AAC9E;EACE,SAAS;EACT,YAAY;AACd;;AAEA,kFAAkF;;AAClF;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA,iFAAiF;;AACjF;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,gDAAgD;;AAChD;EACE,aAAa;AACf;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0CAA0B;EAA1B,kCAA0B;EAA1B,0BAA0B;EAA1B,kDAA0B;AAC5B;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".header-container {\r\n  height: 3.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  border-bottom: 1px solid #e8e8e8;\r\n  padding: 0 24px;\r\n  background: #ffffff;\r\n}\r\n\r\n.header-container .logo img {\r\n  height: 40px;\r\n}\r\n\r\n.logo-dots {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 3px;\r\n  width: 32px;\r\n  height: 32px;\r\n  align-items: center;\r\n  justify-items: center;\r\n}\r\n\r\n.logo-dots > div {\r\n  width: 8px !important;\r\n  height: 8px !important;\r\n}\r\n\r\n.dot-animation {\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.dot-1 {\r\n  animation-delay: 0s;\r\n}\r\n\r\n.dot-2 {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.dot-3 {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.dot-4 {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n.dot-5 {\r\n  animation-delay: 0.8s;\r\n}\r\n\r\n.dot-6 {\r\n  animation-delay: 1.0s;\r\n}\r\n\r\n.dot-7 {\r\n  animation-delay: 1.2s;\r\n}\r\n\r\n.dot-8 {\r\n  animation-delay: 1.4s;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n    transform: scale(1.2);\r\n  }\r\n}\r\n\r\n/* Navigation tabs hosted inside the header, between the logo and the profile.\r\n   Stretch to the full header height and bottom-align so the header's own\r\n   border-bottom doubles as the tab baseline: inactive tabs rest on that line\r\n   and the active tab's ink bar sits right on it. */\r\n.header-tabs {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  align-self: stretch;\r\n  display: flex;\r\n  align-items: stretch;\r\n  margin-left: 24px;\r\n  overflow: hidden;\r\n}\r\n\r\n.header-tabs .ant-tabs {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* Fill the header height so the ink bar lands on the header's bottom border */\r\n.header-tabs .ant-tabs-nav {\r\n  margin: 0;\r\n  height: 100%;\r\n}\r\n\r\n/* Vertically center the labels; the ink bar stays pinned to the bottom = border */\r\n.header-tabs .ant-tabs-nav-wrap {\r\n  align-items: center;\r\n}\r\n\r\n/* Compact tab items: smaller vertical padding + 13px label so they fit the bar */\r\n.header-tabs .ant-tabs-tab {\r\n  padding: 0.5rem 0 !important;\r\n  font-size: 13px;\r\n}\r\n\r\n.header-tabs .ant-tabs-tab + .ant-tabs-tab {\r\n  margin: 0 0 0 1.5rem;\r\n}\r\n\r\n.header-tabs .ant-tabs-tab .anticon {\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n.header-tabs .ant-tabs-nav::before {\r\n  border-bottom: none;\r\n}\r\n\r\n.header-tabs .ant-tabs-top > .ant-tabs-nav {\r\n  background: transparent !important;\r\n}\r\n\r\n/* No empty content panel needed — labels only */\r\n.header-tabs .ant-tabs-content-holder {\r\n  display: none;\r\n}\r\n\r\n.header-right-section {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: auto;\r\n}\r\n\r\n.profile-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.profile-name-dropdown {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #262626;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  padding: 8px 2px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.profile-name-dropdown:hover {\r\n  background-color: #f5f5f5;\r\n  color: #262626;\r\n  text-decoration: none;\r\n}\r\n\r\n.user-name {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #262626;\r\n}\r\n\r\n.dropdown-arrow {\r\n  font-size: 10px;\r\n  color: #8c8c8c;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.profile-name-dropdown:hover .dropdown-arrow {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.logo-text {\r\n  font-family: Inter;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 20px;\r\n  letter-spacing: 0.04px;\r\n  color: #1f2937;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
